export default [
	{//余额明细
		path: 'balance/account',
		name: 'm_balance_account_record',
		props: route => route.params,
		component: () => import('@/pages/finance/balance_account_record_list')
	},
	{//保证金明细
		path: 'deposit/account',
		name: 'm_deposit_account_record',
		props: route => route.params,
		component: () => import('@/pages/finance/deposit_account_record_list')
	},
	{//同售积分明细
		path: 'points/account',
		name: 'm_points_record',
		props: route => route.params,
		component: () => import('@/pages/finance/points_record_list')
	},
	{//IMEI查询积分明细
		path: 'imei/points/account',
		name: 'm_imei_points_record',
		props: route => route.params,
		component: () => import('@/pages/finance/imei_points_record_list')
	},
	{//通联账号列表
		path: 'allinpay/member',
		name: 'm_allinpay_account',
		props: route => route.params,
		component: () => import('@/pages/finance/allinpay_member_list')
	},
	{//绑卡列表列表
		path: 'allinpay/bankcard',
		name: 'm_account_bankcard',
		props: route => route.params,
		component: () => import('@/pages/finance/allinpay_bankcard_list')
	},
	{//对账确认
		path: 'order/check',
		name: 'm_check_confirm',
		props: route => route.params,
		component: () => import('@/pages/finance/order_check_list')
	},
	{//提现审批
		path: 'withdraw/apply',
		name: 'm_withdraw_apply',
		props: route => route.params,
		component: () => import('@/pages/finance/sub_withdraw_apply_list')
	},
	{//预收预付
		path: 'advance/receipt/payment',
		name: 'm_advance_receipt_payment',
		props: route => route.params,
		component: () => import('@/pages/finance/advance_receipt_payment_list')
	},
	{//销售账单
		path: 'sale/bill',
		name: 'm_sale_bill',
		props: route => route.params,
		component: () => import('@/pages/finance/sale_bill_list')
	},
	{//售后账单
		path: 'aftersale/bill',
		name: 'm_after_sale_bill',
		props: route => route.params,
		component: () => import('@/pages/finance/after_sale_bill_list')
	},
	{//采购账单
		path: 'purchase/bill',
		name: 'm_purchase_bill',
		props: route => route.params,
		component: () => import('@/pages/finance/purchase_bill_list')
	},
	{//维修账单
		path: 'repair/bill',
		name: 'm_repair_bill',
		props: route => route.params,
		component: () => import('@/pages/finance/repair_bill_list')
	},
	{//应付账单
		path: 'pay/bill',
		name: 'm_pay_bill',
		props: route => route.params,
		component: () => import('@/pages/finance/pay_bill_list')
	},
	{//授信账单
		path: 'credit/bill',
		name: 'm_credit_bill',
		props: route => route.params,
		component: () => import('@/pages/finance/order_credit_bill_list')
	},
	{//授信还款账单
		path: 'credit/repayment/bill',
		name: 'm_credit_repayment',
		props: route => route.params,
		component: () => import('@/pages/finance/credit_repayment_list')
	},
	{//线下支付对账
		path: 'offline/pay/check',
		name: 'm_offline_pay_check',
		props: route => route.params,
		component: () => import('@/pages/finance/offline_pay_check_list')
	},
	{//应收账款汇总表
		path: 'receivable/summary',
		name: 'm_receivable_summary',
		props: route => route.params,
		component: () => import('@/pages/finance/receivable_summary_list')
	},
	{//应收账款（客户授信应收）
		path: 'receivable',
		name: 'm_sale_receivable',
		props: route => route.params,
		component: () => import('@/pages/finance/sale_receivable_summary_list')
	}
];